import { api } from './api';

export const inboxSyncApi = {
  /**
   * Kick off a Gmail sync for a connected install. Returns immediately —
   * the actual work runs in the inbox-sync queue (or inline when Redis
   * is absent).
   */
  run: async (installId: string): Promise<{ queued: boolean }> => {
    const r = await api.post<{ queued: boolean }>('/api/inbox-sync/run', {
      installId,
    });
    return r.data;
  },
};
